import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  machineCategoriesService,
  type CreateMachineCategoryInput,
  type UpdateMachineCategoryInput,
} from "../../services/admin/machineCategories.service";

export function useMachineCategories() {
  return useQuery({
    queryKey: ["machine-categories"],
    queryFn: () => machineCategoriesService.getAll(),
  });
}

export function useCreateMachineCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateMachineCategoryInput) =>
      machineCategoriesService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["machine-categories"] });
    },
  });
}

export function useUpdateMachineCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateMachineCategoryInput) =>
      machineCategoriesService.update(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["machine-categories"] });
    },
  });
}

export function useDeleteMachineCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => machineCategoriesService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["machine-categories"] });
    },
  });
}
